import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    try {
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
    } catch (e) { }
  }

  ForceCheckOutUtilityLogsSelect(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ForceCheckOutUtilityLogs/Select`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpWiseDetails(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpWiseDetails/Report`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_AdminWiseDetails(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_AdminWiseDetails/Report`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_AdminWiseDetailsCompress(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_AdminWiseDetails_Compress_new/Report`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_Reimbursement(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_Reimbursement/Report`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  EmployeeDurationReport(Detail: any) {
    return this.http.post<any>(environment.API_URL + `EmployeeDuration/Report`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  MISReport(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_MIS/REPORT`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  MusterAttendancePOCMailReport(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_MusterAttendancePOCMailReport/OAS`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_SiteDateWiseManpowerReport(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_SiteDateWiseManpower/Report`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_DeviceReport(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_Device/Report`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
